import { FC } from "react";
import Pill from "@src/lib/ui/Pill";
import {
  PUBLISH_STATE_COLOR,
  PUBLISH_STATE_COPY,
} from "@src/features/contentDetail/utils/courses";
import { PublishState } from "@src/types.generated";

type Props = {
  publishState?: PublishState | null;
  archivedAt?: string | null;
};

const LibraryItemPublishStatePill: FC<Props> = ({
  publishState,
  archivedAt,
}) => {
  if (!publishState) {
    return null;
  }
  return (
    <Pill
      title={archivedAt ? "Archived" : PUBLISH_STATE_COPY[publishState]}
      color={archivedAt ? "gray" : PUBLISH_STATE_COLOR[publishState]}
    />
  );
};

export default LibraryItemPublishStatePill;
